import root from 'window-or-global';

const scrollData = {
    clicked: false,
    clickY: null,
    timer: null,
    isScrolling: false,
    pageX: null,
    pageY: null,
    debug: false,
    containerElement: null,
    classContainer: null,
    disableHoverClass: 'disable-hover',
};

let stopAnimation = null;

const getScroll = function getScroll(element) {
    if (!element) return;
    if (typeof element.scrollTop !== 'undefined') {
        return element.scrollTop;
    } else if (typeof element.scrollY !== 'undefined') {
        return element.scrollY;
    } else {
        return 0;
    }
};

const setScroll = function setScroll(element, position) {
    if (!element) return;
    if (typeof element.scrollTo !== 'undefined') {
        element.scrollTo(0, position);
    } else if (typeof element.scrollTop !== 'undefined') {
        element.scrollTop = position;
    } else {
        console.info('Cannot animate scroll, scrollTo not supported by element');
    }
};

export function animateWithEasing(start, end, duration, requestedTimingFunction, callback) {
    const dimensions = start.length;
    const scrollDeltas = [];
    for (let i = 0; i < dimensions; i++) {
        scrollDeltas.push(end[i] - start[i]);
    }
    const timingFunction = requestedTimingFunction || 'easeOutCubic';
    let currentTime = 0;

    const easingEquations = {
        linear: (time, startValue, changeInValue, duration) => {
            return changeInValue * (time / duration) + startValue;
        },
        easeOutCubic: (time, startValue, changeInValue, duration) => {
            let easeOutTime = time / duration;
            easeOutTime--;
            return changeInValue * (easeOutTime * easeOutTime * easeOutTime + 1) + startValue;
        },
        easeInOutCubic: (time, startValue, changeInValue, duration) => {
            let easeInOutTime = time / duration / 2;
            if (easeInOutTime < 1) {
                return (
                    (changeInValue / 2) * (easeInOutTime * easeInOutTime * easeInOutTime) +
                    startValue
                );
            }
            easeInOutTime -= 2;
            return (
                (changeInValue / 2) * (easeInOutTime * easeInOutTime * easeInOutTime + 2) +
                startValue
            );
        },
    };

    let stopAnimation = false;

    // add animation loop
    function tick() {
        if (stopAnimation) return;
        // 1/60th of a second in ms
        currentTime += 16.666;
        const positions = [];
        for (let i = 0; i < dimensions; i++) {
            positions.push(
                easingEquations[timingFunction](currentTime, start[i], scrollDeltas[i], duration)
            );
        }

        if (currentTime < duration) {
            callback(positions);
            root.requestAnimationFrame(tick);
        } else {
            callback(end);
        }
    }

    // call it once to get started
    tick();
    return () => {
        stopAnimation = true;
    };
}

/**
 * Animate scroll to a Y position
 * @param containerElement the container element to scroll
 * @param scrollY the desired scroll end destination
 * @param duration how long to take to complete the scroll
 * @param requestedTimingFunction linear|easeOutCubic|easeInOutCubic
 */
export function animateScrollToY(scrollY, duration, requestedTimingFunction, containerElement) {
    const container = containerElement || root;
    const scrollTop = getScroll(container);
    stopAnimation = animateWithEasing(
        [scrollTop],
        [scrollY],
        duration,
        requestedTimingFunction,
        setScroll.bind(this, container)
    );
}

const disableContextMenu = function disableContextMenu() {
    //Disable context menu
    root.document.oncontextmenu = root.document.body.oncontextmenu = () => {
        return false;
    };

    root.addEventListener(
        'contextmenu',
        (e) => {
            // Not compatible with IE < 9
            e.preventDefault();
        },
        false
    );
};

const fixPlaceholder = function fixPlaceholder() {
    //Fix for placeholder
    const placeHolders = root.document.querySelectorAll('[placeholder]');
    if (!placeHolders) return;
    for (let i = 0; i < placeHolders.length; i++) {
        const element = placeHolders[i];
        // Attach something similar to this code to text fields with placeholder attributes
        element.placeholderBak = element.placeholder;
        element.onkeyup = function onkeyup() {
            if (this.value.length === 0) {
                element.placeholder = element.placeholderBak;
            } else {
                element.placeholder = '';
            }
        };
    }
};

const attachContainerEvents = function attachContainerEvents() {
    scrollData.containerElement.addEventListener('mousemove', (e) => {
        scrollData.pageX = e.pageX || e.clientX;
        scrollData.pageY = e.pageY || e.clientY;

        if (scrollData.pageX <= 0 || scrollData.pageY <= 0) {
            scrollData.clicked = false;
        } else {
            if (e.which === 3) {
                scrollData.clicked && _updateScrollPos(scrollData, e);
            }
        }
    });
    scrollData.containerElement.addEventListener('mousedown', (e) => {
        if (stopAnimation) stopAnimation();
        if (e.which === 3) {
            // Right mouse
            root.document.body.classList.add('grab-hand');
            e.preventDefault();
            // On mousedown, reset the yValues
            scrollData._pageYValues = [];
            scrollData._pageXValues = [];
            scrollData.clicked = true;
            scrollData.clickY = e.pageY;
            scrollData._initialContainerScroll = scrollData.containerElement.scrollTop;
            return false;
        }
    });
    scrollData.containerElement.addEventListener('mouseleave', (e) => {
        e.preventDefault();
        scrollData.clicked = false;
        root.document.body.classList.remove('grab-hand');
        if (scrollData.isScrolling) {
            scrollData.isScrolling = false;
            _inertialScroll(scrollData);
            return true;
        }
    });
    scrollData.containerElement.addEventListener('mouseup', (e) => {
        if (e.which === 3) {
            e.preventDefault();
            scrollData.clicked = false;
            scrollData.isScrolling = false;
            root.document.body.classList.remove('grab-hand');
            _inertialScroll(scrollData);
            return true;
        }
    });
    scrollData.containerElement.addEventListener('click', (e) => {
        if (scrollData.isScrolling) {
            scrollData.clicked = false;
        }
        return true;
    });
};

export function storeScrollValues(o, e, useClient) {
    //Add values to our queue, but do not let it grow to more than 5 positions
    o._pageYValues.push(useClient ? e.clientY || e.pageY : e.pageY);
    if (o._pageYValues.length > 6) o._pageYValues.shift();

    //Add values to our queue, but do not let it grow to more than 5 positions
    o._pageXValues.push(useClient ? e.clientX || e.pageX : e.pageX);
    if (o._pageXValues.length > 6) o._pageXValues.shift();
}

/**
 * This method is used to update the scroll position of the page as well as set the timer to enable/disable
 * the scroll class
 * @param {object} o - The scrollData object for scroll options
 * @param {event} e - The browser event
 * @private
 */
function _updateScrollPos(o, e) {
    o.isScrolling = true;
    storeScrollValues(o, e);

    //Update the current scroll position
    o.containerElement.scrollTop = o._initialContainerScroll + o.clickY - e.pageY;

    clearTimeout(o.timer);
    if (!o.classContainer.classList.contains(o.disableHoverClass)) {
        o.classContainer.classList.add(o.disableHoverClass);
    }

    o.timer = setTimeout(() => {
        o.classContainer.classList.remove(o.disableHoverClass);
    }, o.timeout);
}

function calculateEndingPosition(scrollValues, scrollFriction, minScrollDuration, debugLog) {
    if (scrollValues.length < 5) return;
    const currentScroll = scrollValues[scrollValues.length - 1];
    // Standardize the events starting at zero axis
    const numValues = scrollValues.length;
    let sumX = 0;
    let sumY = 0;
    let sumXX = 0;
    let sumXY = 0;
    const flingMultiplier = 1.2;
    const durationScale = 0.8;
    const durationPrimer = minScrollDuration === undefined ? 100 : minScrollDuration;
    const durationMultiplier = 2;
    const friction = scrollFriction || -1.2;
    let flingValues = 'Standardized values: ';
    let distances = 'Distance values: ';
    let positions = 'Mouse Positions: ';
    const scrollDirection = scrollValues[numValues - 2] - scrollValues[numValues - 1] > 0 ? -1 : 1;
    if (debugLog) {
        console.log(`Scroll direction: ${scrollDirection}`);
    }
    const scrollDistance = [0];
    for (let i = 1; i < numValues; i++) {
        scrollDistance[i] = Math.abs(scrollValues[i] - scrollValues[i - 1]);
        sumX += i;
        sumY += scrollDistance[i];
        sumXX += i * i;
        sumXY += i * scrollDistance[i];
        if (debugLog) {
            flingValues += `${scrollDistance[i]}, `;
            distances += `${scrollDistance[i]}, `;
            positions += `${scrollValues[i]}, `;
        }
    }
    if (debugLog) {
        console.log(positions);
        console.log(distances);
        console.log(flingValues);
    }

    // Solve for least squares regression line
    const slope = (numValues * sumXY - sumX * sumY) / (numValues * sumXX - sumX * sumX);
    const intercept = (sumY - slope * sumX) / numValues;
    const flingVelocity = flingMultiplier * (intercept + slope * numValues);
    if (debugLog) {
        console.log(`Calculated Linear Regression: y = (${slope})x + (${intercept})`);
        console.log(`Fling Velocity: ${flingVelocity}`);
    }

    const changeInScroll = Math.abs(scrollValues[scrollValues.length - 1] - scrollValues[0]);
    if (debugLog) {
        console.log(`Change in Scroll: ${changeInScroll}`);
    }

    // Solve quadratic formula to find zeroes
    const endingTime = _positiveQuadraticRoot(friction, Math.abs(flingVelocity), changeInScroll);
    if (debugLog) {
        console.log(`Positive Root (ending time): ${endingTime}`);
    }

    // Plug into distance formula to find ending position
    const endingPartial = (friction * endingTime * endingTime) / 2 + flingVelocity * endingTime;

    // Calculate the ending scroll position given the direction and partial
    let endingPosition = currentScroll + scrollDirection * endingPartial;
    if (debugLog) {
        console.log(`Ending Scroll Position: ${endingPosition}`);
    }

    // Clamp ending Position
    if (endingPosition < 0) endingPosition = 0;

    //Get the animation duration (function of length of scroll)
    const computedScrollDistance = durationScale * Math.abs(endingPosition - currentScroll);
    const duration = Math.min(
        (durationPrimer + computedScrollDistance * durationMultiplier) / durationMultiplier,
        2000
    );
    if (debugLog) {
        console.log(
            `Computed Scroll Distance: ${computedScrollDistance}, Scroll Duration: ${duration}`
        );
    }

    return {endingPosition, duration};
}

/**
 * This method is used to simulate an inertial scroll when using the right mouse button.  It will get an idea of the
 * latest scroll speed and it will animate the page in that direction.
 * @param {object} o - The scrollData object for scroll status/options
 * @private
 */
function _inertialScroll(o) {
    //Calculate t
    const yScroll = calculateEndingPosition(o._pageYValues);

    if (yScroll) {
        //Animate the screen to the desired location with the given speed
        animateScrollToY(o.containerElement, yScroll.endingPosition, yScroll.duration);
    }
}

function _positiveQuadraticRoot(a, b, c) {
    const plusRoot = (-1 * b + Math.sqrt(b * b - 4 * a * c)) / (2 * a);
    const minusRoot = (-1 * b - Math.sqrt(b * b - 4 * a * c)) / (2 * a);
    // console.log("Calculated quadratic roots: + " + plusRoot + ", - " + minusRoot);
    if (plusRoot > 0 && minusRoot > 0) {
        return plusRoot > minusRoot ? plusRoot : minusRoot;
    } else if (plusRoot > 0) {
        return plusRoot;
    } else {
        return minusRoot;
    }
}

export default function initScroll(containerElement) {
    disableContextMenu();
    fixPlaceholder();
    if (!containerElement) {
        console.warn(
            'Initialization of scroll container defaulting to body, no element provided to attach to.'
        );
        scrollData.containerElement = root.document.body;
    } else {
        scrollData.containerElement = containerElement;
    }
    scrollData.classContainer = root.document.body;
    attachContainerEvents();
}
